import request from "@/utils/request";

export function getDataStore(storeName) {
  return request({
    url: `store/egift?store_name=${storeName}`,
    method: "get"
  });
}

export function createPayment(data) {
  return request({
    url: `egift/order`,
    method: "post",
    data
  });
}
